import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Toggle.scss";

const ENTER_KEY = "Enter";

export class Toggle extends React.Component {
  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Whether the toggle can be clicked or not */
    disabled: PropTypes.bool,
    /** Default state for toggle */
    defaultIsToggled: PropTypes.bool,
    /** Controlled state for toggle */
    isToggled: PropTypes.bool,
    /** Callback function when clicked */
    onClick: PropTypes.func,
    /** Additional children to be rendered */
    children: PropTypes.node,
    /** Id associated with component */
    id: PropTypes.any,
    /** Value associated with component */
    value: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      toggled: props.defaultIsToggled || props.isToggled || false,
    };
  }

  componentDidUpdate(prevProps) {
    const { isToggled } = this.props;
    if (isToggled !== undefined && isToggled !== prevProps.isToggled) {
      this.setState({ toggled: isToggled });
    }
  }

  onClick = () => {
    const { disabled, id, isToggled, onClick, value } = this.props;
    const { toggled } = this.state;

    if (disabled) {
      return;
    }

    if (isToggled === undefined) {
      this.setState({ toggled: !toggled });
    }

    let returnValue;
    if (!toggled) {
      returnValue = value;
    } else {
      returnValue = null;
    }

    if (onClick) {
      onClick({
        id,
        toggle: !toggled,
        value: returnValue,
      });
    }
  };

  onKeyDownHandler = (event) => {
    if (event.key === ENTER_KEY) {
      this.onClick();
    }
  };

  render() {
    const { children, className, disabled } = this.props;
    const { toggled } = this.state;

    const toggleClass = classNames(
      "react-toggle",
      {
        on: toggled,
        disabled,
      },
      className
    );

    return (
      <div
        onClick={this.onClick}
        onKeyDown={this.onKeyDownHandler}
        role="button"
        className={toggleClass}
        tabIndex={0}
        data-testid="Toggle"
      >
        {children}
      </div>
    );
  }
}

export default Toggle;
